export const decimalHelper = { isDecimal };

function isDecimal(s) {
  return !isNaN(parseFloat(s)) && isFinite(s);
}
